import { ContentDialog } from "../../../components/MDDForm/components/ContentDialog.jsx";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Spinner from "@accredo/fe-shared/components/Spinner.jsx";
import BookingExportPaymentsTable from "../../../components/tables/BookingExportPaymentsTable.jsx";
import BookingExportBookingsTable from "../../../components/tables/BookingExportBookingsTable.jsx";
import DsButton from "@accredo/fe-shared/theme/components/Button.jsx";
import { getEuro, getDatumZeit } from "@accredo/fe-shared/services/formatService.js";

const BookingExportInfoModal = ({
  open,
  bookingExport,
  onClose,
  isLoading,
}) => {
  const payments = bookingExport?.payments || [];
  const bookings = bookingExport?.bookings || [];

  // Wie in BookingExportsTable.jsx (ExportBookingsDetail): die Buchungen
  // des Exports werden im renderDetailPanel der Zahlungen-Tabelle gezeigt.
  const renderBookingsDetailPanel = () => (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Buchungen in diesem Export ({bookings.length})
      </Typography>
      <BookingExportBookingsTable bookings={bookings} />
    </Box>
  );

  return (
    <ContentDialog
      openCD={open}
      setOpenCD={onClose}
      tca={{
        title: bookingExport
          ? `Buchungsexport - ${bookingExport.export_identifier}`
          : "Buchungsexport",
        content: isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 300,
            }}
          >
            <Spinner size={32} />
          </Box>
        ) : bookingExport ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                columnGap: 2,
                rowGap: 1,
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Summe:
              </Typography>
              <Typography variant="body2">
                {getEuro(bookingExport.summe)}
              </Typography>

              <Typography variant="body2" fontWeight="bold">
                Erstellt von:
              </Typography>
              <Typography variant="body2">
                {bookingExport.created_by?.full_name || "-"}
              </Typography>

              <Typography variant="body2" fontWeight="bold">
                Erstellt am:
              </Typography>
              <Typography variant="body2">
                {getDatumZeit(bookingExport.created_at)}
              </Typography>

              <Typography variant="body2" fontWeight="bold">
                Abgeschlossen am:
              </Typography>
              <Typography variant="body2">
                {getDatumZeit(bookingExport.finished_at)}
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                Zahlungen in diesem Export ({payments.length})
              </Typography>
              <BookingExportPaymentsTable
                payments={payments}
                renderDetailPanel={renderBookingsDetailPanel}
                enableExpandAll={false}
                initialState={{ expanded: true }}
                enableTopToolbar={false}
                enablePagination={false}
              />
            </Box>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Keine Daten verfügbar
          </Typography>
        ),
        actions: bookingExport ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              width: "100%",
            }}
          >
            <DsButton variant="tertiary" onClick={onClose}>
              Schließen
            </DsButton>
          </Box>
        ) : null,
      }}
      maxWidth="lg"
    />
  );
};

BookingExportInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  bookingExport: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default BookingExportInfoModal;
